// Container/Damage API
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type ContainerDamageRequests = {
    filterRequest: RequestConfigFunction<{params: any}>,
    get: RequestConfigFunction<{id: number}>,
    update: RequestConfigFunction<{id: number}>,
    create: RequestConfigFunction,
    modifications: RequestConfigFunction<{id: number}>,
    reopen: RequestConfigFunction<{id: number}>,
}

const containerDamageRequests: ContainerDamageRequests = {
    filterRequest: ({
        params,
    }) => {
        return {
            method: 'POST',
            url: 'damage/filter-request/all',
            ...params,
        }
    },
    get: ({
        id,
    }) => {
        return {
            url: `damage/${id}`,
            method: 'GET',
        }
    },
    update: ({
        id,
    }) => {
        return {
            url: `damage/${id}`,
            method: 'PUT',
        }
    },
    create: () => {
        return {
            url: 'damage',
            method: 'POST',
        }
    },
    modifications: ({
        id,
    }) => {
        return {
            url: `damage/${id}/modifications`,
            method: 'GET',
        }
    },
    reopen: ({
        id,
    }) => {
        return {
            url: `damage/${id}/reopen`,
            method: 'POST',
        }
    },
}

export default containerDamageRequests
